export function isPathActive(pathname: string, basePath: string): boolean {
  if (basePath === '/') {
    return pathname === '/';
  }
  return pathname === basePath || pathname.startsWith(`${basePath}/`);
}
